import React, { lazy } from 'react';
export function DesignOptions() {
  const options = [{
    title: 'Glass Designs & Textures',
    copy: "Choose from clear glass, frosted glass, rain glass, reeded glass, textured glass, tinted glass and other decorative options. Kosin's offers 18 designs and textures customized to fit your space."
  }, {
    title: 'Hardware Finishes',
    copy: 'Select hinges, handles, clips, towel bars and brackets in finishes that complement your bathroom, including modern black, brushed nickel, brass-inspired tones and other available options.'
  }, {
    title: 'Protective Coatings',
    copy: 'Ask about water-repellent glass coatings that help reduce water spots, soap scum and everyday cleaning time.'
  }];
  const gallery = [{
    url: 'https://cdn.magicpatterns.com/uploads/4fXA2y9HE9kV4VPD5tfUj4/GSDpic5.webp',
    alt: "Custom frameless glass shower enclosure with marble tile installed by Kosin's Glass",
    caption: 'Frameless Enclosure'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/o43RcMjWkzoqErKvc88Bft/GSDpic1.webp',
    alt: "Frameless glass shower with neo-angle layout, subway tile and bench seat by Kosin's Glass",
    caption: 'Neo-Angle Frameless'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/3dFEqBspuy24G379oFCrkW/GSDpic3.webp',
    alt: "Frameless walk-in glass shower with frosted privacy panel, marble walls and teak bench by Kosin's Glass",
    caption: 'Walk-In with Frosted Panel'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/7geDRzwyJG9LzAFVFRRYmw/GSDpic2.webp',
    alt: "Frameless glass corner shower enclosure with textured tile and candle ledge by Kosin's Glass",
    caption: 'Frameless Corner Enclosure'
  }];
  return <section className="py-20 bg-navy text-white overflow-hidden" data-id="element-1518">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1519">
        <div className="max-w-3xl mb-16 anim-on-scroll" data-id="element-1520">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 tracking-tight" data-id="element-1521">
            Glass, Hardware & Finish Options That Fit Your Style
          </h2>
          <p className="text-lg text-blue-100" data-id="element-1522">
            Your shower glass should match the rest of your bathroom. Kosin's
            Glass offers a wide selection of glass textures, designs, hardware
            finishes, colors and styles so your enclosure feels custom from
            every angle.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-1523">
          {options.map((opt, i) => <div key={i} className="bg-navy-800 p-8 rounded-2xl border border-navy-700 scroll-fade-up" style={{
          animationDelay: `${i * 0.1}s`
        }} data-id="element-1524">
              <h3 className="text-xl font-bold mb-4" data-id="element-1525">{opt.title}</h3>
              <p className="text-blue-100 leading-relaxed" data-id="element-1526">{opt.copy}</p>
            </div>)}
        </div>
        <div className="anim-on-scroll" data-id="element-1527">
          <div className="mb-8 flex items-end justify-between flex-wrap gap-3" data-id="element-1528">
            <div data-id="element-1529">
              <p className="text-xs font-semibold tracking-[0.2em] uppercase text-primary mb-2" data-id="element-1530">
                Recent Projects
              </p>
              <h3 className="text-2xl md:text-3xl font-semibold tracking-wide" data-id="element-1531">
                Custom Shower Glass Installed by Kosin's
              </h3>
            </div>
            <p className="text-sm text-blue-100/80 max-w-sm" data-id="element-1532">
              A look at real frameless and custom shower enclosures designed,
              measured and installed for Southeast Michigan homeowners.
            </p>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1533">
            {gallery.map((img, i) => <figure key={i} className="aspect-[3/4] rounded-2xl overflow-hidden bg-navy-800 relative group ring-1 ring-white/10" data-id="element-1534">
                <img src={img.url} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" data-id="element-1535" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" data-id="element-1536" />
                <figcaption className="absolute bottom-0 left-0 right-0 p-4" data-id="element-1537">
                  <span className="text-xs uppercase tracking-[0.18em] text-white/70 block mb-1" data-id="element-1538">
                    Kosin's Install
                  </span>
                  <span className="text-sm md:text-base italic text-white" data-id="element-1539">
                    {img.caption}
                  </span>
                </figcaption>
              </figure>)}
          </div>
        </div>
      </div>
    </section>;
}